import {useEffect, useState} from "react";
import axios from "axios";
import {SERVICES_API_URL} from "../../config";
import _ from "lodash";
import {useOktaAuth} from "@okta/okta-react";
import log from "loglevel";

export interface ChatUserDetails {
  userId: string;
  userToken: string;
  apiKey: string;
}

const useChatUserDetails = (driverMessaging: boolean) => {
  const [chatUserDetails, setChatUserDetails] = useState<ChatUserDetails | null>();
  const {oktaAuth} = useOktaAuth();

  useEffect(() => {
    const fetchUserDetails = async () => {
      const accessToken = oktaAuth.getAccessToken();
      if (driverMessaging && accessToken) {
        try {
          const response = await axios.get(`${SERVICES_API_URL}/chat/user-details`, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          });

          if (response.data && response.status === 200) {
            const newDetails = response.data as ChatUserDetails;
            log.debug("Retrieved chat user details", newDetails);
            if (!_.isEqual(chatUserDetails, newDetails)) {
              log.debug("Updating chat user details", newDetails);
              setChatUserDetails(newDetails);
            }
          } else {
            log.error("Error retrieving user details for chat", response.data);
          }
        } catch (error) {
          log.error("Error fetching user details for chat", error);
        }
      }
    };

    fetchUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driverMessaging, oktaAuth]);

  return chatUserDetails;
};

export default useChatUserDetails;
